export default __webpack_public_path__ + "static/media/banner2.a9dc587e.jpg";